// Matt: "at the end of the game [it'd be fun to] have some stats there
// aside from just points... the more numbers there are there the better."
// Purely cosmetic/informational - nothing here feeds back into scoring or
// legality checks, so a missed increment is a display gap, not a rules bug.
// Hooked into each mechanic's own single choke point (performBuy,
// performLevelUp, destroyFromHand/discardFromHand/gainCurse,
// useHandCardAbility, chooseMonster, revealHand, rest/prepare,
// familiarActions) rather than diffing state generically, so every stat's
// origin is traceable to one obvious call site.
export function createEmptyStats() {
  return {
    villageVisits: 0,
    dungeonVisits: 0,
    dungeonWins: 0,
    dungeonLosses: 0,
    cardsBought: 0,
    goldSpent: 0,
    heroesLeveledUp: 0,
    cardsDestroyed: 0,
    cardsDiscardedByEffect: 0,
    cursesGained: 0,
    timesRested: 0,
    timesPrepared: 0,
    villageAbilitiesUsed: 0,
    dungeonAbilitiesUsed: 0,
    spoilsAbilitiesUsed: 0,
    familiarAbilitiesUsed: 0,
    familiarTaken: false,
  };
}

// Immutable update: returns a new state with players[playerId].stats[key]
// incremented by `amount` (default 1). Used from every mechanic that wants
// to record itself, rather than one central place trying to infer what
// happened from a before/after diff.
export function incrementStat(state, playerId, key, amount = 1) {
  return {
    ...state,
    players: state.players.map((p) => (p.id === playerId
      ? { ...p, stats: { ...p.stats, [key]: p.stats[key] + amount } }
      : p)),
  };
}

// familiarTaken is a boolean flag, not a running count - same shape (an
// immutable per-player stats update) but a dedicated setter reads clearer
// than incrementStat with a non-numeric "amount".
export function setStatFlag(state, playerId, key, value) {
  return {
    ...state,
    players: state.players.map((p) => (p.id === playerId
      ? { ...p, stats: { ...p.stats, [key]: value } }
      : p)),
  };
}
